import Vue from "vue";
import Vuex from "vuex";

import issue from "./issue.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        issue,
        auth
    }
});